export interface IListener<T> {
  (event: T): any;
}

export interface IDisposable {
  dispose();
}

/** passes through events as they happen. You will not get events from before you start listening */
export class TypedEvent<T> {
  private listeners: IListener<T>[] = [];
  private expendableListeners: IListener<T>[] = [];

  public addListener(listener: IListener<T>): IDisposable {
    this.listeners.push(listener);
    return {
      dispose: () => this.removeListener(listener),
    };
  };

  public once(listener: IListener<T>): void {
    this.expendableListeners.push(listener);
  };

  public removeListener(listener: IListener<T>) {
    let index = this.listeners.indexOf(listener);
    if (index > -1) this.listeners.splice(index, 1);
  };

  public emit(value: T) {
    this.listeners.forEach((listener) => listener(value));

    if (this.expendableListeners.length > 0) {
			this.expendableListeners.forEach((listener) => listener(value));
			
			this.expendableListeners = [];
    }
  };

  public pipe(typedEvent: TypedEvent<T>): IDisposable {
    return this.addListener((e) => typedEvent.emit(e));
  };
}
